import type { Locale } from "../../shared/types";
import { LOCALES, useI18n } from "../i18n/I18nProvider";

export function LanguageSwitcher() {
  const { locale, setLocale, t } = useI18n();
  return (
    <div className="lang-switch" role="group" aria-label={t("lang.label")}>
      {LOCALES.map((l: Locale) => (
        <button
          key={l}
          type="button"
          className={l === locale ? "lang-btn is-active" : "lang-btn"}
          aria-pressed={l === locale}
          lang={l}
          title={t(`lang.${l}`)}
          onClick={() => setLocale(l)}
        >
          {l.toUpperCase()}
        </button>
      ))}
    </div>
  );
}
